// client/src/api/ApiDashboard.js
import flex from './FlexFetch'

const dashboard_endpoint = '/api/1.0/dashboard/'

/**
 * Get dashboard summary - all dashboard data in one API call
 * Returns: leagues, nextMatch, recentAwards, overdueMatchesCount, proposals
 */
async function getSummary() {
  try {
    const response = await flex.flexFetch(dashboard_endpoint + 'summary', {
      method: 'GET',
      credentials: 'include',
    })
    return await flex.handleResponse(response)
  } catch (error) {
    console.error('Failed to get dashboard summary:', error)
    throw error
  }
}

const ApiDashboard = {
  getSummary,
}

export default ApiDashboard
